import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import { useNavigate } from 'react-router-dom'; // Use useNavigate from react-router-dom
import Footer from './Footer.js';  // Import Footer component
import { BASE_URL } from "./Constants.js";
import { BASE_URL1 } from "./Constants.js";

const Manage_User = () => {
  const [showModal, setShowModal] = useState(false);
  const [paymentUrl, setPaymentUrl] = useState('');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [users, setUsers] = useState([]); // State to store users data
  const [user, setUser] = useState([]); // State to store user data
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true); // State for loading indicator
  const [error, setError] = useState(null); // State for error handling
  const [dressTypes, setDressTypes] = useState([]); // State to store dress types
  const [dressSizes, setDressSizes] = useState([]); // State to store dress sizes
  const [dressColors, setDressColors] = useState([]); // State to store dress colors

  const [searchQuery, setSearchQuery] = useState(''); // Search query state
  const [departmentFilter, setDepartmentFilter] = useState(''); // Department filter state
  const [Locations, setLocations] = useState([]);

  const [locationFilter, setLocationFilter] = useState(''); // Location filter state
  const [genderFilter, setGenderFilter] = useState(''); // Gender filter state

  const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
  const [usersPerPage] = useState(10); // Users per page for pagination

  const navigate = useNavigate(); // Use useNavigate for page navigation
  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };
  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Handle department filter change
  const handleDepartmentFilterChange = (e) => {
    setDepartmentFilter(e.target.value);
  };

  // Handle location filter change
  const handleLocationFilterChange = (e) => {
    setLocationFilter(e.target.value);
  };

  // Handle gender filter change
  const handleGenderFilterChange = (e) => {
    setGenderFilter(e.target.value);
  };

  // Handle page change for pagination
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

 const profile_details =  sessionStorage.getItem('userProfile');
 console.log("session_values",profile_details);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem('authToken');
      if (!token) {
        setError('No token found!');
        setLoading(false);
        return;
      }

      try {
        // Fetch profile to check if the user is an admin
        const profileResponse = await fetch(`${BASE_URL}profile`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const profileData = await profileResponse.json();
        if (profileData && profileData.profile) {
          setUser(profileData.profile.is_uniform_access_given); // Safely access is_admin if profile exists
        } else {
          setError('Profile data not found');
        }

        // Fetch users data
        const usersResponse = await fetch(`${BASE_URL}candidates`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const usersData = await usersResponse.json();
        if (usersData && usersData.employees && Array.isArray(usersData.employees)) {
          setUsers(usersData.employees);
        } else {
          setError('No users found');
        }

        // Fetch dress types
        const dressTypesResponse = await fetch(`${BASE_URL}dress_types`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const dressTypesData = await dressTypesResponse.json();
        if (dressTypesData && dressTypesData.dressTypes) {
          const activeDressTypes = dressTypesData.dressTypes.filter(type => type.status === 'A');
          setDressTypes(activeDressTypes);
        }

        // Fetch dress sizes
        const dressSizesResponse = await fetch(`${BASE_URL}dress_sizes`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const dressSizesData = await dressSizesResponse.json();
        if (dressSizesData && dressSizesData.dressSizes) {
          const activeDressSizes = dressSizesData.dressSizes.filter(size => size.status === 'A');
          setDressSizes(activeDressSizes);
        }

        // Fetch dress colors
        const dressColorsResponse = await fetch(`${BASE_URL}dress_colors`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const dressColorsData = await dressColorsResponse.json();
        if (dressColorsData && dressColorsData.dressColors) {
          const activeDressColors = dressColorsData.dressColors.filter(color => color.status === 'A');
          setDressColors(activeDressColors);
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array ensures this effect runs once on component mount

  useEffect(() => {
    const fetchDepts = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}get_depts`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch departments');
        }

        const data = await response.json();
        if (data && data.status && Array.isArray(data.data)) {
          setDepartments(data.data); // Save the department list
        } else {
          setError('No departments found');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDepts();
  }, []);

  useEffect(() => {
    const fetchLocs = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}get_locs`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch departments');
        }

        const data = await response.json();
        if (data && data.status && Array.isArray(data.data)) {
          setLocations(data.data); // Save the department list
        } else {
          setError('No departments found');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchLocs();
  }, []);


  // Function to handle adding a user (navigate to the "Add Candidate" page)
  const handleAddUser = () => {
    navigate('/add_candidate');
  };

  // Function to get the dress type name by ID
  const getDressTypeName = (id) => {
    const dressType = dressTypes.find(type => type.id === id);
    return dressType ? dressType.dress_type : 'Unknown';
  };

  // Function to get the dress size name by ID
  const getDressSizeName = (id) => {
    const dressSize = dressSizes.find(size => size.id === id);
    return dressSize ? dressSize.dress_size : 'Unknown';
  };

  // Function to get the dress color name by ID
  const getDressColorName = (id) => {
    const dressColor = dressColors.find(color => color.id === id);
    return dressColor ? dressColor.dress_color : 'Unknown';
  };

  // Filter users based on search and filter criteria
  const filteredUsers = users.filter((user) => {
    const nameMatches = user.candidate_name.toLowerCase().includes(searchQuery.toLowerCase());
    const departmentMatches = !departmentFilter || user.department === departmentFilter;
    const locationMatches = !locationFilter || user.location === locationFilter;
    const genderMatches = !genderFilter || user.gender === genderFilter;

    return nameMatches && departmentMatches && locationMatches && genderMatches;
  });

  // Pagination logic
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(filteredUsers.length / usersPerPage); i++) {
    pageNumbers.push(i);
  }

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }


  return (
    <div className='page-wrapper'>
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div
        className="page-container"
        style={{
          marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '250px' : '0',
          transition: 'margin-left 0.3s ease',
        }}
      >
        <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <button
                      className="btn btn-primary"
                      onClick={handleAddUser}
                    >
                      Issue Uniform
                    </button>
                  </div>

                  {/* Search and Filter Controls */}
                  <div className="d-flex justify-content-between mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by name"
                      value={searchQuery}
                      onChange={handleSearchChange}
                    />
                    <select
                      className="form-control ml-2"
                      value={departmentFilter}
                      onChange={handleDepartmentFilterChange}
                    >
                      <option value="">All Departments</option>
                      {departments.map((dept, index) => (
                        <option key={index} value={dept.EREC_APVC_Dept}>
                          {dept.EREC_APVC_Dept}
                        </option>
                      ))}
                    </select>
                    <select
                      className="form-control ml-2"
                      value={locationFilter}
                      onChange={handleLocationFilterChange}
                    >
                      <option value="">All Locations</option>
                      {Locations.map((loc, index) => (
                        <option key={index} value={loc.EREC_MKOF_lblCity}>
                          {loc.EREC_MKOF_lblCity}
                        </option>
                      ))}
                    </select>
                    <select
                      className="form-control ml-2"
                      value={genderFilter}
                      onChange={handleGenderFilterChange}
                    >
                      <option value="">All Genders</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </div>

                  {/* User Table */}
                  <div className="table-responsive table--no-card m-b-30">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr><th>#</th>
                          <th>Date of Paid</th>
                          <th>Name</th>
                          <th>Gender</th>
                          <th>Department</th>
                          <th>Location</th>
                          <th>Payment Mode</th>
                          <th>Payment Status</th>
                          <th>Total Amount</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentUsers.map((user) => {
                          const encodedId = btoa(user.id.toString()); // Encode the user.id to base64

                          return (
                            <tr key={user.id}>
                              <td>{user.id}</td>
                              <td>{user.created_on ? user.created_on.substring(0, 10) : 'Not provided'}</td>

                              <td>{user.candidate_name}</td>
                              <td>{user.gender}</td>
                              <td>{user.department}</td>
                              <td>{user.location}</td>
                              <td>{user.payment_mode}</td>
                              <td>{user.payment_status}</td>
                              <td className="text-right">{user.cost}</td>

                              <td className="d-flex align-items-center">
                                {/* Print Button */}
                                {user.payment_status === 'Approved' && (
                                <a
                                  href={`/printk/${user.id}`}
                                  target="_blank"
                                  style={{ marginRight: "8px" }}
                                >
                                  <button
                                    type="button"
                                    className="btn btn-success d-flex align-items-center justify-content-center"
                                    style={{ height: "38px", width: "40px" }}
                                    title="Print"
                                  >
                                    <i className="fas fa-print"></i>
                                  </button>
                                </a>)}

                                {/* Pay Button - only if payment is pending */}
                                {user.payment_status === 'Pending' && (
                                  <button
                                    type="button"
                                    className="btn btn-primary d-flex align-items-center justify-content-center"
                                    style={{ height: "38px", width: "40px" }}
                                    title="Pay Now"
                                    onClick={() => {
                                      const encodedId = btoa(user.id.toString());
                                      const encodedPaymentMode = btoa(user.payment_mode.toString());
                                      setPaymentUrl(`${BASE_URL1}payment/initiatePayment.php?id=${encodedId}&payment_type=${encodedPaymentMode}`);
                                      setShowModal(true);
                                    }}
                                  >
                                    <i className="fas fa-credit-card"></i>
                                  </button>
                                )}

                                {user.payment_status === 'Approved' && user.delivery_status === 'N' && (
                                                                  <button
                                                                    type="button"
                                                                    className="btn btn-warning d-flex align-items-center justify-content-center"
                                                                    style={{ height: "38px", width: "40px" }}
                                                                    title="Delivery Status"
                                                                    onClick={async () => {
                                                                      try {
                                                                        const token = localStorage.getItem('authToken'); // if needed
                                                                        const response = await fetch(`${BASE_URL}create_otp`, {
                                                                          method: 'POST',
                                                                          headers: {
                                                                            'Content-Type': 'application/json',
                                                                            'Authorization': `Bearer ${token}`, // remove if not required
                                                                          },
                                                                          body: JSON.stringify({ id: user.id }),
                                                                        });
                                
                                                                        const data = await response.json();
                                                                        if (data.status) {
                                                                          navigate(`/otp_screen1/${user.id}`);
                                                                          // optionally update state or redirect
                                                                        } else {
                                                                          console.log("Failed to create OTP.");
                                                                        }
                                                                      } catch (err) {
                                                                        console.error("Error creating OTP:", err);
                                                                        console.log("Error while creating OTP.");
                                                                      }
                                                                    }}
                                                                  >
                                                                    <i className="fas fa-truck"></i>
                                                                  </button>
                                                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  <nav className="pagination-container">
                    <ul className="pagination justify-content-center">
                      {/* Previous button with left arrow */}
                      {currentPage > 1 && (
                        <li className="page-item">
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage - 1)}
                          >
                            &lt; {/* Left Arrow (Unicode) */}
                          </button>
                        </li>
                      )}

                      {/* Show limited page numbers (3 before and after the current page) */}
                      {pageNumbers
                        .filter((number) => number >= currentPage - 2 && number <= currentPage + 2)
                        .map((number) => (
                          <li
                            key={number}
                            className={`page-item ${currentPage === number ? 'active' : ''}`}
                          >
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(number)}
                            >
                              {number}
                            </button>
                          </li>
                        ))}

                      {/* Next button with right arrow */}
                      {currentPage < pageNumbers.length && (
                        <li className="page-item">
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage + 1)}
                          >
                            &gt; {/* Right Arrow (Unicode) */}
                          </button>
                        </li>
                      )}
                    </ul>
                  </nav>

                  {/* Total Pages Display */}
                  <div className="text-center mt-2">
                    <span>Page {currentPage} of {pageNumbers.length}</span>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Payment Link</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>You can use the link below to proceed with the payment:</p>
                <a href={paymentUrl} target="_blank" rel="noopener noreferrer">
                  {paymentUrl}
                </a>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
                <a
                  href={paymentUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                >
                  Open Payment
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Manage_User;